import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getMessaging } from "firebase/messaging";
const firebaseConfig = {
    apiKey: "AIzaSyBaYqzCkN__iORKWtl5nsb-Bt1LrWFi1mI",
    authDomain: "coredination-app.firebaseapp.com",
    projectId: "coredination-app",
    storageBucket: "coredination-app.appspot.com",
    messagingSenderId: "1015159425465",
    appId: "1:1015159425465:web:e142d25687e6905fd28e68",
    measurementId: "G-8RM4D5FFK5"
};
export const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const vapidKey = "BGAWoTwD02v16n68Q4vUuRvM3SxjQI42sJLyO4U_yYEqCMIhqqAnL4RC0tpwnB5K--u7T6_WLCeJLpbOC_YnTJ4"

let msging
try {
    msging = getMessaging(app)
} catch (error) {
    console.error('Couldn\'t set up Firebase messaging', error)
}
export const messaging = msging